import { render, staticRenderFns } from "./Card_phone.vue?vue&type=template&id=2c533af9&scoped=true&"
var script = {}
import style0 from "./Card_phone.vue?vue&type=style&index=0&id=2c533af9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c533af9",
  null
  
)

export default component.exports